import { createAsyncThunk } from '@reduxjs/toolkit';

import { AtashsooziOmumiApiPaths } from 'Feature/Atashsoozi/Constant/AtashsooziOmumiApiPaths';
import {
  AtashsooziHttpPostService,
  AtashsooziOmumiHttpGetService,
} from 'Feature/Atashsoozi/Services/AtashsooziHttpServices';
import { BasicInfoApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/BasicInfoApiPaths';
import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';

export const addToOrder = createAsyncThunk('bimehNameh/addToOrder', async (command: any) => {
  return await AtashsooziHttpPostService({
    url: `${AtashsooziOmumiApiPaths.BimehNameh.AddToOrder}`,
    body: command,
  });
});

export const bimehNamehAtashsooziSaderShodeh = createAsyncThunk(
  'bimehNameh/BimehNamehAtashsooziSaderShodeh',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths?.BimehNameh.BimehNamehAtashsooziSaderShodeh}`,
      params: query,
    });
  }
);

export const getActiveAnvaeSazeh = createAsyncThunk('noeSazeh/GetActiveAnvaeSazeh', async () => {
  return await AtashsooziOmumiHttpGetService({
    url: `${AtashsooziOmumiApiPaths.NoeSazeh.GetActiveAnvaeSazeh}`,
  });
});

export const getActiveAnvaeFaaliatByNoeBimehNameh = createAsyncThunk(
  'noeFaaliat/getActiveAnvaeFaaliatByNoeBimehNameh',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths.NoeFaaliat.GetActiveAnvaeFaaliatByNoeBimehNameh}`,
      params: { query },
    });
  }
);

export const getActivePoosheshHayeEzafi = createAsyncThunk(
  'poosheshEzafi/GetActivePoosheshHayeEzafi',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths.PoosheshEzafi.GetActivePoosheshHayeEzafi}`,
      params: query,
    });
  }
);

export const getActiveGoroohHayeMoredBimeh = createAsyncThunk(
  'GoroohMoredBimeh/getActiveGoroohHayeMoredBimeh',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths.GoroohMoredBimeh.GetActiveGoroohHayeMoredBimeh}`,
      params: query,
    });
  }
);

export const estelamAtashsooziOmumi = createAsyncThunk('bimehNameh/estelamOmumi', async (command: any) => {
  return await AtashsooziHttpPostService({
    url: `${AtashsooziOmumiApiPaths.BimehNameh.EstelamOmumi}`,
    body: command,
  });
});

export const getBimehNamehAtashsooziConfig = createAsyncThunk('bimehNameh/GetBimehNamehAtashsooziConfig', async () => {
  return await AtashsooziOmumiHttpGetService({
    url: `${AtashsooziOmumiApiPaths.BimehNameh.GetBimehNamehAtashsooziConfig}`,
  });
});

export const getDescriptionsByNoeBimehNameh = createAsyncThunk(
  'bimehNameh/GetDescriptionsByNoeBimehNameh',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths.GoroohMoredBimeh.GetDescriptionsByNoeBimehNameh}`,
      params: query,
    });
  }
);

export const getPoosheshEzafiShowInSodoor = createAsyncThunk(
  'bimehNameh/getPoosheshEzafiShowInSodoor',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths.PoosheshEzafi.GetShowInSodoor}`,
      params: query,
    });
  }
);

export const createShenasehPardakhtAtashsoozi = createAsyncThunk(
  'bimehNameh/CreateShenasehPardakht',
  async (command: any) => {
    return await AtashsooziHttpPostService({
      url: `${AtashsooziOmumiApiPaths.BimehNameh.CreateShenasehPardakht}`,
      body: command,
    });
  }
);

export const addToOrderAtashsoozi = createAsyncThunk(
  'bimehNameh/AddBimehNamehAtashsooziToOrderWepod',
  async (command: any) => {
    return await AtashsooziHttpPostService({
      url: `${AtashsooziOmumiApiPaths.BimehNameh.AddBimehNamehAtashsooziToOrderWepod}`,
      body: command,
    });
  }
);

export const GetAllAnvaeSherkatBimeh = createAsyncThunk('NoeSherkatBimeh/GetAllAnvaeSherkatBimeh', async () => {
  return await BasicInfoHttpGetService({
    url: `${BasicInfoApiPaths.NoeSherkatBimeh.GetAllAnvaeSherkatBimeh}`,
  });
});

export const printBimehNamehAtashsooziById = createAsyncThunk(
  'ShakhSalesBimehNamehPrint/printBimehNamehAtashsooziById',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths.BimehNameh.PrintBimehNamehAtashsooziById}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);
